<template>
  <v-container fluid pa-0>
    <v-layout>
      <image-slider></image-slider>
    </v-layout>
    <v-layout>
      <v-flex xs12 grey class="elevation-inset-20">
        <news class="pb-5"></news>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  // eslint-disable-next-line import/extensions
  import {mapGetters} from 'vuex';
  import ImageSlider from './content/ImageSlider';
  import news from './content/News';

  export default {
    name: 'index',
    components: {
      ImageSlider, news,
    },
    data() {
      return {
        msg: 'Welcome to Your Vue.js App',
        activeArr: [false, false, false, false],
        active: 0,
        myHTML: '',
      };
    },
    computed: {
      ...mapGetters(['allSliders', 'allNews']),
    },
    methods: {},
    mounted() {
        setTimeout(()=> {   this.$vuetify.goTo(0, {offset: 0, duration: 300, easing: 'easeOutCubic'})},100)
    },
    created() {
      // console.log('created Index')
    },
  };
</script>
